const HANDLED_CHANGE = 'HANDLED_CHANGE';
const HANDLED_VALIDATED_FIELD = 'HANDLED_VALIDATED_FIELD';
const HANDLED_VALIDATED_FIELDS = 'HANDLED_VALIDATED_FIELDS';
const SET_MESSAGE = 'SET_MESSAGE';
const FETCHED_CONTRACT = 'FETCHED_CONTRACT';
const SAVED_CONTRACT = 'SAVED_CONTRACT';
const LAUNCHED_CONTRACT_TOGGLE = 'LAUNCHED_CONTRACT_TOGGLE';
const SENT_TOKENS = 'SENT_TOKENS';
const RESET_FORM = 'RESET_FORM';

export {
  HANDLED_CHANGE,
  HANDLED_VALIDATED_FIELD,
  HANDLED_VALIDATED_FIELDS,
  SET_MESSAGE,
  FETCHED_CONTRACT,
  SAVED_CONTRACT,
  LAUNCHED_CONTRACT_TOGGLE,
  SENT_TOKENS,
  RESET_FORM,
};



// WEBPACK FOOTER //
// ./src/actionTypes.js